module.exports = __webpack_public_path__ + "static/media/Severus Snape 1.6c8faf1a.jpg";